import React from 'react';
import type { IconProps } from '../types';

export const GradingForm = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M10.5 2.33h7v4.67h-7z" />
    <path d="M4.67 7h18.67v16.33H4.67z" />
    <path d="M9.33 11.67h9.33M9.33 16.33h7" />
  </svg>
);

export default GradingForm;
